module.exports = __webpack_public_path__ + "static/media/delete-icon.82621552.svg";